import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {firestorePlugin} from 'vuefire'
import {vuexfireMutations, firestoreAction} from 'vuexfire'
import EventCode from "@/components/EventCode";
import Home from "@/components/Home";
import Teams from "@/components/Teams";
import Boats from "@/components/Boats";
import Rounds from "@/components/Rounds";
import Admin from "@/components/Admin";
import Results from "@/components/Results";
import ResultEntry from "@/components/ResultEntry";
import Vuex from 'vuex'
import {db} from "@/db";
import '@mdi/font/css/materialdesignicons.css'
import Tools from "@/components/Tools";
import AddTeam from "@/components/AddTeam";
import RoundsWide from "@/components/RoundsWide";

const routes = [
    {path: '/eventCode', component: EventCode},
    {path: '/', component: Home},
    {path: '/teams', component: Teams},
    {path: '/boats', component: Boats},
    {path: '/rounds', component: Rounds},
    {path: '/roundsWide', component: RoundsWide},
    {path: '/results', component: Results},
    {path: '/result/:className/:round/:race', component: ResultEntry},
    {path: '/admin', component: Admin},
    {path: '/tools', component: Tools},
    {path: '/addTeam', component: AddTeam},
]

const router = new VueRouter({
    routes // short for `routes: routes`
})

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        event: {},
        teams: {},
        boatGroups: {},
        rounds: {},
        boatGroupIndex: 0,
        showExtras:0
    },
    mutations: {
        ...vuexfireMutations,
        updateRounds(state, newRounds) {
            state.rounds = newRounds;
        },
        incrementBoatGroupIndex (state) {
            if(state.boatGroupIndex===state.boatGroups.length-1){
                state.boatGroupIndex=0;
            } else{
                state.boatGroupIndex++;
            }
        },
        resetBoatGroupIndex (state) {
            state.boatGroupIndex=0;
        },
        updateBoatGroupIndex (state, newValue) {
            state.boatGroupIndex=newValue;
        },
        incrementExtras (state){
            state.showExtras++
        }
    },
    getters: {
        getBoatGroupIndex: state => {
            return state.boatGroupIndex;
        },
        displayExtras: state => {
            return state.showExtras>11;
        }

    },

    actions: {
        bindEvent: firestoreAction(({bindFirestoreRef}
            , eventCode) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('event', db.collection(`events`).doc(eventCode.id))
        }),
        bindTeams: firestoreAction(({bindFirestoreRef}
            , eventCode) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('teams', db.collection(`events/${eventCode.id}/teams`))
        }),
        bindBoatGroups: firestoreAction(({bindFirestoreRef}
            , eventCode) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('boatGroups', db.collection(`events/${eventCode.id}/boatGroups`))
        }),
        bindRounds: firestoreAction(({bindFirestoreRef}
            , eventCode) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('rounds', db.collection(`events/${eventCode.id}/rounds`).orderBy("number"))
        }),
    },
});


Vue.use(firestorePlugin)
Vue.use(VueRouter)
Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
